<template>
    <div> 
        <div class="row">
            <div class="col-md-12">
                <ul class="list-group">
                    <a class="list-group-item text-center tit-list-group-item font-weight-bold text-black-50" style="color: #cccccc!important; background-color: #343a40; padding: 5px;">RESUMO DAS CONTAS</a>
                    <a v-for="(conta, index) in lstcontas" v-bind:key="index" class="list-group-item list-group-item-action lstdetrec">{{mtdformatarzeros(conta.id, 2)}} - {{conta.descricao}} <span class="badge badge-secondary bdgtitulos">{{ mtdformatavalordecimal(conta.saldo) }}</span></a>

                    <a v-if="psomacontas >= 0" class="list-group-item list-group-item-action lstdetrec">SOMA DAS CONTAS <span class="badge badge-success bdgtitulos" style="background-color: #0acf97;">{{ mtdformatavalordecimal(psomacontas) }}</span></a>

                    <a v-else class="list-group-item list-group-item-action lstdetrec">SOMA DAS CONTAS <span class="badge badge-danger bdgtitulos" style="background-color: #f82b54;">{{ mtdformatavalordecimal(psomacontas) }}</span></a>         
                </ul>                                   
            </div>
        </div>
    </div>
</template>

<script>
import util from '../../utilitarios/util';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
    name: "BarChartCard",

    components:{
    'dashboard_skeleton'   : Skeletondashboard
  },
    data : function name(params) {
        return {
        usuariologado               : this.$store.state.usuario,

        pdiasemovimento: 0,
        pqtdregistros: 10,
        lstcontas   : [],
        psomacontas: 0,
        isloading: false,
    
        }
   
    },
    props: [
        'utodasfiliais',
        'idfilialmeta',
        'pdtini',
        'pdtfim',
        'lstfiliais',
        'qtdnotaspendentes',
    ],
    methods:{
            mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},   
            mtdformatavalordecimal(valor){
                    return util.formatarvalor(valor, '');
            },
            mtdmaisfiltro(){
                let rfiltro = '';
                // if (parseInt(this.pdiasemovimento) > 0) {//guga - 24/10/2024 - 🤠
                    const dataAtual = new Date();
                    const diasemovimento = parseInt(this.pdiasemovimento);
            
                    const dataLimiteInferior = new Date();
                    dataLimiteInferior.setDate(dataAtual.getDate() - diasemovimento);

                    // const dataLimiteSuperior = new Date();
                    // dataLimiteSuperior.setDate(dataAtual.getDate() - diasemovimento + 1);

                    const formatoData = (data) => {
                        const ano = data.getFullYear();
                        const mes = String(data.getMonth() + 1).padStart(2, '0');
                        const dia = String(data.getDate()).padStart(2, '0');

                        return `${ano}-${mes}-${dia}`;
                    };

                    // Filtro para produtos com exatamente 'pdiasemovimento' dias sem vendas
                    rfiltro = rfiltro + ' and p.dtultimavenda < "' + formatoData(dataLimiteInferior) + ' 00:00:00" ';
                    // console.log(rfiltro);
                // }
                return rfiltro;
            },
            mtdcarregalancamentos(ipagina){
                var vself       = this;
                vself.$emit('handlerLoader', true);
                // let filtro      = vself.mtdmaisfiltro();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'saldocaixa'},
                    {parametro: 'filtrocontas', valor  : JSON.stringify(vself.lstfiliais) ?? []},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
                retorno.then(function (response) {
                    vself.lstcontas          = response.data.contas;
                    vself.psomacontas        = 0;
                    for (var i = 0; i < vself.lstcontas.length; i++) {
                        vself.psomacontas = vself.psomacontas + parseFloat(vself.lstcontas[i]['saldo']);
                    }                        

                    vself.$emit('handlerLoader', false);
                }).catch(function (response) {         
                    vself.lstcontas          = [];
                    vself.psomacontas        = 0;     
                    vself.$emit('handlerLoader', false);
                });
            },
        },
    mounted(){
        setTimeout(() => {
            this.mtdcarregalancamentos();
        }, 3000);
    },
    computed:{
    },
    }
</script>